import React from 'react';
import 'rc-texty/assets/index.css';
import 'rc-banner-anim/assets/index.css';
import './index.scss';
import pre_video from '../../img/pre_videoNew.jpg';

interface IProps {
  defaultStringAll: string[];
}
const Banner = (props: IProps) => {
  return (
    <div className='baner-wrap'>
      {/* <video
        className='baner-video'
        poster='../../../static/imgs/pre_video.png'
        src='https://img03.az.jd.com/ins-user-m/develop/website/sp2.mp4'
        // src='https://open-cdn.zhongan.com/dm-instrument/files/lhmmilzqbxv0jhmzbqupfdewkzoadekdscbjydnz.mp4'
        loop
        preload='metadata'
        muted
        autoPlay
      ></video> */}

      <video
        className='baner-video'
        poster={pre_video}
        loop
        preload='metadata'
        playsInline
        muted
        autoPlay
        // data-wf-ignore='true'
        // data-object-fit='cover'
      >
        <source
          src='https://img03.az.jd.com/ins-user-m/develop/website/sp3.mp4'
          type='video/mp4'
        />
        <source
          src='https://img03.az.jd.com/ins-user-m/develop/website/sp3.mp4'
          type='video/ogg'
        />
        <source
          src='https://img03.az.jd.com/ins-user-m/develop/website/sp3.mp4'
          type='video/webm'
        />
      </video>
    </div>
  );
};

export default Banner;
